import React from 'react';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';

const useStyles = makeStyles<Theme>((theme) => ({
  card: {
    marginBottom: theme.spacing(2),
    width: '100%',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  cardHeader: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textAlign: 'center',
  },
  cardBody: {
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  section: {
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    width: '100%',
    maxWidth: '800px',
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
    textAlign: 'center',
  },
  list: {
    paddingLeft: theme.spacing(2),
    maxWidth: '800px',
    margin: '0 auto',
    textAlign: 'left',
  },
  description: {
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto',
  },
}));

interface HowToUseProps {
  title: string;
  whatIsIt: string;
  description: string;
  featuresTitle: string;
  features: string[];
  howToUseTitle: string;
  steps: string[];
  tipsTitle: string;
  tips: string[];
}

export default function HowToUse({
  whatIsIt,
  description,
  featuresTitle,
  features,
  howToUseTitle,
  steps,
  tipsTitle,
  tips,
}: HowToUseProps) {
  const classes = useStyles();

  return (
    <GridContainer justify="center">
      <GridItem xs={12} sm={12} md={12}>
        <Card className={classes.card}>
          <CardBody className={classes.cardBody}>
            <div className={classes.section}>
              <h5 className={classes.sectionTitle}>{whatIsIt}</h5>
              <p className={classes.description}>{description}</p>
            </div>

            <div className={classes.section}>
              <h5 className={classes.sectionTitle}>{featuresTitle}</h5>
              <ul className={classes.list}>
                {features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>
            </div>

            <div className={classes.section}>
              <h5 className={classes.sectionTitle}>{howToUseTitle}</h5>
              <ol className={classes.list}>
                {steps.map((step, index) => (
                  <li key={index}>{step}</li>
                ))}
              </ol>
            </div>

            <div className={classes.section}>
              <h5 className={classes.sectionTitle}>{tipsTitle}</h5>
              <ul className={classes.list}>
                {tips.map((tip, index) => (
                  <li key={index}>{tip}</li>
                ))}
              </ul>
            </div>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
